import { sortBy } from "lodash-es";
import { union } from "lodash";

export { default as leaveUtils } from "./leaves";

export const filterListWithSearch = (list, search) => {
  return list.filter((student) =>
    (
      student.first_name.toLowerCase() +
      " " +
      student.last_name.toLowerCase()
    ).includes(search.toLowerCase())
  );
};

export const sortLeaves = (leaves) => {
  let sortedLeaves = [];
  if (leaves.length > 0 && leaves[0].last_name) {
    sortedLeaves = sortBy(leaves, "last_name");
  } else {
    sortedLeaves = sortBy(leaves, "start_date");
  }
  return sortedLeaves;
};

export const sortPosts = (posts, desc = false) => {
  let sortedPosts = sortBy(posts, "post_time");
  // let sortedPinned = sortBy(pinned.filter(post => post.gender_tag.length === 0 || post.gender_tag.includes(profile.gender)), 'post_time')
  // sortedPinned = sortedPinned.reverse()
  if (desc === true) {
    return sortedPosts.reverse();
  }
  return sortedPosts;
};

export const getAudienceString = (post, school) => {
  let result = [];
  if (post.gender_tag.length > 0) {
    let genderResult = post.gender_tag
      .map((item) => (item === "M" ? "Male" : "Female"))
      .join(", ");
    result.push(genderResult);
  }
  if (post.grade_tag.length > 0) {
    let gradeResult = post.grade_tag.map((item) =>
      item === "3" ? item + "rd Form" : item + "th Form"
    );
    result.push(gradeResult);
  }

  if (post.dorm_tag.length > 0) {
    let dormResult = post.dorm_tag
      .map((item) => (school.dormMap[item] ? school.dormMap[item].name : ""))
      .join(", ");
    result.push(dormResult);
  }
  return result;
};

export const filterStudentsByName = (students, search) => {
  if (search !== null && students && students.length > 0) {
    return students.filter((student) => {
      // console.log(student)
      if (student.first_name) {
        return (
          student.first_name.toLowerCase() +
          " " +
          student.last_name.toLowerCase()
        ).includes(search.toLowerCase());
      } else {
        return false;
      }
    });
  } else {
    return [];
  }
};

export const returnFilterString = (filters, school) => {
  let filterTitle = "All Students";

  let result = [];
  if (filters.health && filters.health.length > 0) {
    let healthResult = filters.health
      .map((item) => {
        if (item === "healthy") {
          return "Healthy";
        } else if (item === "unhealthy") {
          return "Unhealthy";
        } else {
          return "Unsubmitted";
        }
      })
      .join(", ");
    result.push(healthResult);
  }
  if (filters.gender && filters.gender.length > 0) {
    let genderResult = filters.gender
      .map((item) => (item === "M" ? "Male" : "Female"))
      .join(", ");
    result.push(genderResult);
  }
  if (filters.grade && filters.grade.length > 0) {
    let gradeResult = filters.grade.map((item) =>
      item === "3" ? item + "rd Form" : item + "th Form"
    );
    result.push(gradeResult);
  }
  if (filters.dorm && filters.dorm.length > 0) {
    let dormResult = filters.dorm
      .map((item) => school.subDormMap[item].name)
      .join(", ");
    result.push(dormResult);
  }
  if (filters.location && filters.location.length > 0) {
    let locationResult = filters.location
      .map((item) => school.locations.map[item].name)
      .join(", ");
    result.push(locationResult);
  }

  if (filters.type && filters.type.length > 0) {
    let typeResult = [];
    if (filters.type.includes("D")) typeResult.push("Day");

    if (filters.type.includes("B")) typeResult.push("Boarding");
    result.push(typeResult.join(", "));
  }

  if (result.length > 0) {
    filterTitle = result.join(", ");
    // showClear = true
  }
  return filterTitle;
};

export const returnFacultyFilterString = (filters) => {
  let filterTitle = "All Faculties";

  let result = [];
  if (filters && filters.gender.length > 0) {
    let genderResult = filters.gender
      .map((item) => (item === "M" ? "Male" : "Female"))
      .join(", ");
    result.push(genderResult);
  }

  if (filters && filters.type && filters.type.length > 0) {
    let typeResult = [];
    if (filters.type.includes("S")) typeResult.push("Staff");

    if (filters.type.includes("E")) typeResult.push("Employee");
    result.push(typeResult.join(", "));
  }

  if (result.length > 0) {
    filterTitle = result.join(", ");
  }

  return filterTitle;
};

export const getTimeStamp = () => {
  return Math.floor(Date.now() / 1000);
};

export const filterActiveResults = (members) => {
  let result = [];
  if (members.length > 0)
    result = members.filter((mem) => mem.activated !== false);
  return result;
};

export const filterSearchResults = (filters, students) => {
  let result = filterActiveResults(students);
  if (students.length > 0) {
    if (filters.health && filters.health.length > 0) {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      let todayEpoch = Math.floor(today.getTime() / 1000);

      let healthy = [];
      let unhealthy = [];
      let unsubmitted = [];

      filters.health.map((filter) => {
        if (filter === "healthy") {
          healthy = result.filter(
            (student) =>
              student.healthy !== null &&
              student.healthy === true &&
              (student.health_last_updated &&
                student.health_last_updated >= todayEpoch)
          );
        } else if (filter === "unhealthy") {
          unhealthy = result.filter(
            (student) =>
              student.healthy !== null &&
              student.healthy === false &&
              (student.health_last_updated &&
                student.health_last_updated >= todayEpoch)
          );
        } else if (filter === "unsubmitted") {
          unsubmitted = result.filter(
            (student) =>
              !student.health_last_updated ||
              (student.health_last_updated &&
                student.health_last_updated < todayEpoch)
          );
        }
        return null;
      });

      result = union(healthy, unhealthy, unsubmitted);
    }

    if (filters.gender && filters.gender.length > 0) {
      result = result.filter((student) =>
        filters.gender.includes(student.gender)
      );
    }
    if (filters.grade && filters.grade.length > 0) {
      result = result.filter((student) => {
        return (
          student.grade && filters.grade.includes(student.grade.toString())
        );
      });
    }
    if (filters.dorm && filters.dorm.length > 0) {
      result = result.filter((student) =>
        filters.dorm.includes(student.sub_dorm)
      );
    }
    if (filters.location && filters.location.length > 0) {
      result = result.filter((student) =>
        filters.location.includes(student.current_location)
      );
    }
    if (filters.type && filters.type.length > 0) {
      // todo filter intersts
      if (filters.type.includes("B")) {
        result = result.filter((student) => student.is_boarding === true);
      }
      if (filters.type.includes("D")) {
        result = result.filter((student) => student.is_boarding === false);
      }

      // result = result.filter(student => filters[4].includes(student.itnerest))
    }
  }
  // let sortedResult = sortBy(result, 'last_name')
  return result;
  // this.setState({searchResult: result})
};

export const filterSearchFacultyResults = (filters, faculties) => {
  let result = filterActiveResults(faculties);
  if (faculties.length > 0) {
    if (filters.gender.length > 0) {
      result = result.filter((faculty) =>
        filters.gender.includes(faculty.gender)
      );
    }
    if (filters.type.length > 0) {
      if (filters.type.includes("S")) {
        result = result.filter((faculty) => faculty.is_staff === true);
      }
      if (filters.type.includes("E")) {
        result = result.filter((faculty) => faculty.is_staff !== true);
      }
    }
  }

  return result;
};

export const returnWithRosterFilterString = (rosterFilter, filterTitle) => {
  let newText = "";
  rosterFilter &&
    rosterFilter.forEach((obj) => {
      newText = newText + ", " + obj.name;
    });
  if (newText === ", " || newText === "") {
    return filterTitle;
  } else {
    if (filterTitle === "All Students") {
      return newText.substr(2);
    } else {
      return filterTitle + newText;
    }
  }
};

export const isMobile = () => {
  let isMobile = false;
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    isMobile = true;
  }
  return isMobile;
};

export const isIOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase(),
    ios = /iphone|ipod|ipad/.test(userAgent);
  if (ios) {
    return true;
  } else {
    return false;
  }
};
